import { Button, Typography, useMediaQuery } from '@mui/material';
import { Champ, UserDetail } from '../../types';
import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import createAxiosInstance from '../../api/axiosConfig';
import { CDN_PRIZES_API } from '../../api/endpoint';

const Prices = () => {
  const [champs, setChamps] = useState<Champ[]>([]);
  const [userDetails, setUserDetails] = useState<UserDetail[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState<string | null>(null);
  const isFetching = useRef(false);
  const [activeSlide, setActiveSlide] = useState(2);
  const [stopExecution, setStopExecution] = useState<boolean | null>(false);
  const scrollRef = useRef(null);
  const scrollSpeed = 50;
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const isMobile = useMediaQuery('(max-width:600px)');

  const getPrizes = async () => {
    setLoading(true);
    try {
      const axiosInstance = createAxiosInstance(true);
      const response = await axiosInstance.get(`${CDN_PRIZES_API}`, {});
      setData(response.data.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPrizes();
  }, []);

  useEffect(() => {
    const scrollContainer: any = scrollRef.current;
    if (!scrollContainer) return;

    let interval = setInterval(() => {
      if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
        scrollContainer.scrollLeft = 0;
      } else {
        scrollContainer.scrollLeft += 1;
      }
    }, scrollSpeed);

    const handleMouseEnter = () => clearInterval(interval);
    const handleMouseLeave = () => {
      interval = setInterval(() => {
        if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
          scrollContainer.scrollLeft = 0;
        } else {
          scrollContainer.scrollLeft += 1;
        }
      }, scrollSpeed);
    };

    scrollContainer.addEventListener('mouseenter', handleMouseEnter);
    scrollContainer.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      clearInterval(interval);
      scrollContainer.removeEventListener('mouseenter', handleMouseEnter);
      scrollContainer.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [userDetails]);

  if (error) {
    return (
      <Typography variant="h6" color="error">
        Error: {error}
      </Typography>
    );
  }

  const handleClick = (item: any) => {
    navigate(`/prizes/${item.reward_id}`, {
      state: { item }
    });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: isMobile ? '4rem 0 3rem 0' : '5rem  0'
      }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          flexWrap: isMobile ? 'wrap' : 'nowrap'
        }}>
        <Typography
          sx={{
            color: 'white',
            letterSpacing: isMobile ? 1 : 3,
            marginBottom: isMobile ? 2 : 5,
            fontFamily: 'Baloo2',
            fontSize: isMobile ? '24px' : '48px',
            fontWeight: 800,
            textAlign: isMobile ? 'left' : 'center',
            flex: 1,
            paddingLeft: '10rem'
          }}>
          {`Prizes To Win`}
        </Typography>
        <Button onClick={() => navigate('/Prizes', {})} sx={{ textTransform: 'none' }}>
          <Typography
            sx={{
              fontWeight: 400,
              color: 'white',
              fontFamily: 'Baloo2',
              fontSize: isMobile ? '12px' : '21px',
              padding: '0 10px',
              cursor: 'pointer'
            }}>
            view all
          </Typography>
        </Button>
      </div>
      <Box
        ref={scrollRef}
        sx={{
          display: 'flex',
          gap: '10px',
          overflowX: 'auto',
          whiteSpace: 'nowrap',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          width: '100%',
          padding: '16px'
        }}>
        {data.map((item: any, index: number) => (
          <Box
            key={index}
            sx={{ alignItems: 'center', padding: '0 0 0 10px ', cursor: 'pointer' }}
            onClick={() => handleClick(item)}>
            <Box sx={{}}>
              <img
                style={{
                  width: isMobile ? '100px' : '200px',
                  height: isMobile ? '100px' : '200px'
                }}
                src={`${process.env.REACT_APP_DEFAULT_AVATAR}/APP/PrizeAvatars/${item?.avatar}`}
                alt={'prices'}></img>
            </Box>
            <Typography
              sx={{
                textAlign: 'center',
                padding: '10px',
                fontSize: isMobile ? '14px' : '29px',
                color: 'white',
                fontWeight: 700,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: isMobile ? '100px' : '200px'
              }}>
              {item.name}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Prices;
